/**
 * Schedule a callback for browser idle time, falling back to a short timeout
 * in environments without `requestIdleCallback` (Safari). Shared by deferred,
 * non-critical boot work — Sentry Session Replay (main.tsx) and the RUM
 * beacon (rum.ts) — so there's one idle-scheduling policy, not one per call
 * site.
 */
export const scheduleIdle: (cb: () => void) => void =
  typeof requestIdleCallback === 'function'
    ? requestIdleCallback
    : (cb) => setTimeout(cb, 2000);
